<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <app-header-noauth class="appHeader appHeader--sticky appHeader--noauth"></app-header-noauth>
  <div
    [ngClass]="backGroundBanner"
    class="banner"
    fxLayout="row"
    fxLayoutAlign="center center"
    fxFlex="100%"
    fxFlex.sm="50%"
    fxFlex.md="50%"
    fxFlex.lg="60%"
    fxFlex.xl="100%"
  >
    <div class="wrapper wrapper--noauth banner__content">
      <div class="wrapper__content">
        <mat-card class="form-container" fxFlex="100%" fxFlex.gt-xs="310px">
          <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
            <h2><b translate>mat.form.field.title</b></h2>
            <mat-divider class="form__divider"></mat-divider>
            <div class="form__login-fields-container" fxLayout="column" fxLayoutGap="0.2em">
              <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                <mat-label translate>mat.form.field.username.placeholder</mat-label>
                <input
                  id="usernameLogin"
                  type="text"
                  matInput
                  formControlName="username"
                  autocomplete="username"
                  required
                  autocomplete="off"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                <mat-label translate>mat.form.field.password.placeholder</mat-label>
                <input
                  id="passwordLogin"
                  type="password"
                  matInput
                  formControlName="password"
                  autocomplete="current-password"
                  required
                  autocomplete="off"
                />
                <mat-error
                  *ngIf="
                    loginForm.controls.password.invalid &&
                    loginForm.controls.password.touched &&
                    !loginForm.controls.password.errors?.attributions
                  "
                >
                  <span translate>mat.form.field.password.error</span>
                </mat-error>
                <mat-error
                  *ngIf="loginForm.controls.password.errors?.attributions && loginForm.controls.password.touched"
                >
                  <span translate>mat.form.field.attributions.error</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutGap="1.5em" class="form__footer form-footer">
              <div fxLayout="row" fxLayoutAlign="end">
                <button
                  id="loginButtonLogin"
                  mat-flat-button
                  color="accent"
                  type="submit"
                  [disabled]="loginForm.invalid"
                >
                  <span translate>mat.form.button</span>
                </button>
              </div>
              <div class="form__forget-container" fxFlex fxLayoutAlign="center center">
                <a id="forgottenPasswordLogin" class="form__forget-link" (click)="openDialog()" translate>
                  mat.form.span.getPassword
                </a>
              </div>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="wrapper wrapper--noauth login__grid-container" fxLayout="column" fxLayoutGap="1em" fxFlex="100%">
    <div class="wrapper__content">
      <mat-divider></mat-divider>
      <div fxFlex>
        <mat-grid-list class="login__grid-list" [cols]="colsList" [rowHeight]="rowHeightList" gutterSize="1em">
          <!--First Tile Desktop-->
          <mat-grid-tile
            [ngClass]="backGroundGrid"
            colspan="1"
            rowspan="7.5"
            class="grid__first-tile"
            *ngIf="screenType === 'Desktop'"
          >
            <div class="firstTile__container--desktop" fxLayout="column" fxLayoutAlign="end start">
              <button
                id="groupWebLinkLogin"
                mat-flat-button
                color="accent"
                [ngClass.lt-md]="{ custom: true }"
                (click)="openURL('https://www.linkedin.com/company/sabadellconsumerfinance')"
                value
              >
                <span class="firstTile__button-span" translate>mat.grid.list.tile.first.button</span>
              </button>
            </div>
          </mat-grid-tile>

          <!--Second Tile-->
          <mat-grid-tile [colspan]="colTileTelephone" [rowspan]="rowTileTelephone">
            <mat-card
              fxFlex="100%"
              class="secondTile__container"
              [fxLayout]="screenType === 'Mobile' ? 'column' : 'row'"
              fxLayoutAlign="space-between"
            >
              <div class="info-colaborador" fxFlex fxLayoutAlign="start center" fxLayoutGap="16px">
                <span class="banner_contact_img"></span>

                <div fxFlex class="mat-h2 info-colaborador__title" translate>
                  <strong translate>mat.grid.list.tile.second.telefono</strong>
                </div>
              </div>
              <div fxFlex [fxLayout]="screenType === 'Mobile' ? 'column' : 'row'" fxLayoutGap="16px">
                <div class="card__container-divider">
                  <mat-divider [vertical]="screenType === 'Mobile' ? false : true" class="card__divider"></mat-divider>
                </div>
                <div fxFlex fxLayout="column" fxLayoutAlign="center" class="card__subtitle">
                  <span translate>
                    <strong translate>mat.grid.list.tile.second.global</strong>mat.grid.list.tile.second.auto
                  </span>
                  <h2><strong translate>mat.grid.list.tile.second.auto.telefono</strong></h2>
                </div>
                <div class="card__container-divider">
                  <mat-divider [vertical]="screenType === 'Mobile' ? false : true" class="card__divider"></mat-divider>
                </div>
                <div fxFlex fxLayout="column" fxLayoutAlign="center" class="card__subtitle">
                  <span translate>
                    <strong translate>mat.grid.list.tile.second.global</strong>mat.grid.list.tile.second.consumo
                  </span>
                  <h2><strong translate>mat.grid.list.tile.second.consumo.telefono</strong></h2>
                </div>
              </div>
            </mat-card>
          </mat-grid-tile>

          <!--First Tile-->
          <mat-grid-tile
            colspan="1"
            rowspan="5"
            class="grid__first-tile--Mobile"
            *ngIf="screenType == 'Tablet' || screenType == 'Mobile'"
          >
            <div fxLayout="column" fxLayoutAlign="end start" class="firstTile__container--mobile">
              <button id="groupWebLinkLogin" mat-flat-button color="accent">
                <span class="firstTile__button-span">{{
                  'mat.grid.list.tile.first.button' | translate | uppercase
                }}</span>
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngFor="let image of images"
            [colspan]="image.cols"
            [rowspan]="screenType === 'Mobile' || screenType === 'Tablet' ? 5 : image.rows"
          >
            <div
              [ngClass]="image.id"
              fxFlexFill
              fxLayout="column"
              fxLayoutAlign="end start"
              class="banner_box thirdTile__container"
            >
              <span class="thirdTile__title">
                {{ image.text | translate }}
                <strong translate>{{ image.boldText | translate }}</strong>
              </span>
              <span *ngIf="image.link?.length > 0">
                <strong translate
                  ><a class="banner_link_info" [href]="image.link" translate>mat.grid.list.tile.first.link</a></strong
                >
              </span>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </div>
  </div>
  <app-footer class="appFooter appFooter--noauth"></app-footer>
</div>
